import { isError } from 'flux-standard-action';
import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';

// eslint-disable-next-line consistent-return
const successMutationGenerator = ({ trackChannelEvents, trackClipEvents }) => {
  if (trackChannelEvents) {
    return {
      trackChannelEvents: { $set: true },
    };
  }
  if (trackClipEvents) {
    return {
      trackClipEvents: { $set: true },
    };
  }
  if (!trackChannelEvents && !trackClipEvents) {
    return {
      trackClipEvents: { $set: false },
      trackChannelEvents: { $set: false },
    };
  }
};

const errorMutationGenerator = (error) => ({
  error: { $set: error },
});

const stateMutationGenerator = (action) =>
  isError(action) ? errorMutationGenerator : successMutationGenerator;

export const playbackSessionTrackEventsReducer = (currentState, action) =>
  updateState(currentState, stateMutationGenerator(action)(payloadExtractor(action)));
